import { Dropdown } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'; // Import RSuite CSS

const HoverDropdown = ({ ...props }) => (
  <Dropdown {...props} placement="bottom-end">
    <Dropdown.Item>Set PTT service period</Dropdown.Item>
    <Dropdown.Item>Remote start/shut down voice service</Dropdown.Item>
    <Dropdown.Item>Start/Shut down GPS by batch</Dropdown.Item>
    <Dropdown.Item>Pause/start accounts</Dropdown.Item>
    <Dropdown.Item>delete users</Dropdown.Item>
    <Dropdown.Item>Export</Dropdown.Item>
    <Dropdown.Item>Modify</Dropdown.Item>
    <Dropdown.Item>Change groups</Dropdown.Item>
    <Dropdown.Item>Activate service by batch</Dropdown.Item>
  </Dropdown>
);

export default HoverDropdown;